import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoRecorderOffIcon } from 'assets/svg';
import { TeamingInfo } from 'features/teaming/teaming-base/components';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface TeamTakenProps {
  onCancel: () => void;
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 432px;
  padding: ${theme.spacing(23)};
  border-radius: 8px;
  background: ${theme.palette.grey[900]};
`;

const Icon = styled(VideoRecorderOffIcon)`
  margin-top: ${theme.spacing(7)};
`;

const CancelCallButton = styled(Button)`
  margin-top: ${theme.spacing(16)};
`;

export const TeamTaken: FC<TeamTakenProps> = ({ onCancel }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Icon />
      <Typography
        variant='h1'
        align='center'
        color={theme.palette.common.white}
        mt={15}
        mb={14}
      >
        {t('pleaseWaitConfirm')}
      </Typography>
      <TeamingInfo />
      <CancelCallButton
        fullWidth
        size='small'
        color='secondary'
        data-testid='cancel-call'
        title={t('cancelCall')}
        onClick={() => onCancel()}
      >
        {t('cancelRequest')}
      </CancelCallButton>
    </Container>
  );
};
